import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MailX } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { Loader, ErrorState } from "../../components/common/States";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "none";
  const { data, loading, error } = useApi(`/public/unsubscribe/${token}`);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);
  const confirm = async () => { try { await api.post(`/public/unsubscribe/${token}`); setDone(true); } catch (e) { setErr(formatApiError(e)); } };
  return (
    <div className="mx-auto max-w-md px-4 py-16 text-center" data-testid="unsubscribe-page">
      <MailX className="mx-auto h-10 w-10 text-slate-400" />
      {loading && <Loader />}
      {error && <ErrorState message={error} />}
      {data && (done || data.status === "unsubscribed"
        ? <p className="mt-4 text-lg font-medium" data-testid="unsubscribe-done">Vous ne recevrez plus les communications de {data.company_name}.</p>
        : <>
          <p className="mt-4 text-lg font-medium">Se désinscrire des communications de {data.company_name}</p>
          <p className="mt-1 text-sm text-slate-500">Adresse : {data.email}. Les emails liés à vos dossiers (réponses, suivi) restent envoyés.</p>
          <Button className="mt-6" onClick={confirm} data-testid="unsubscribe-confirm">Confirmer la désinscription</Button>
          {err && <p className="mt-3 text-sm text-rose-600">{err}</p>}
        </>)}
    </div>
  );
}
